// extracted by mini-css-extract-plugin
export default {"root":"TripsPage_root__ql+D6","darkMode":"TripsPage_darkMode__-syL8","appBar":"TripsPage_appBar__eFTtO","hiddenButton":"TripsPage_hiddenButton__g1Zab"};